import "./shop.css";
import tea from "../assets/image/tea-hel.jpg";
import { FaHeart, FaShoppingCart } from "react-icons/fa";
import product1 from "assets/image/shop/03.jpg";
import product2 from "assets/image/shop/04.jpg";
import product3 from "assets/image/shop/06.jpg";
import product4 from "assets/image/shop/07.jpg";

export default function Shop() {
  return (
    <>
      <div className="container">
        <h5 className="py-3 fs-18" style={{ borderBottom: "3px dashed rgb(10, 10, 68)" }}>
          محصولات
        </h5>
        <h6 className="py-3 fw-bold">سوغاتی</h6>
        {/* <div id="products" class="d-flex flex-wrap justify-content-center justify-content-md-start"> */}
        <div className="d-flex justify-content-between m-0 flex-wrap">
          <div className="product border border-success round pt-4 mx-1 my-2">
            <div className="text-center">
              <img src={product1} width="170px" alt="not found" />
            </div>
            <h5 className="product-title size3 px-3 pb-3 mt-2">کشک گوسفندی</h5>
            <h6 className="product-price color-red digits px-3 pb-1 ms-3 fw-bold">35,000 تومان</h6>
            <div className="d-flex justify-content-center justify-content-sm-start ms-3 px-3 mb-4">
              <span style={{ cursor: "pointer" }}>
                <FaHeart className="color-red"></FaHeart>
              </span>
              <span style={{ cursor: "pointer" }} className="mx-3">
                <FaShoppingCart className="color-red" />
              </span>
            </div>
          </div>

          <div className="product border border-success round pt-4 mx-1 my-2">
            <div className="text-center">
              <img src={product2} width="170px" alt="not found" />
            </div>
            <h5 className="product-title size3 px-3 pb-3 mt-2">چای سرگل پاییزه</h5>
            <h6 className="product-price color-red digits px-3 pb-1 ms-3 fw-bold">90,000 تومان</h6>
            <div className="d-flex justify-content-center justify-content-sm-start ms-3 px-3 mb-4">
              <span style={{ cursor: "pointer" }}>
                <FaHeart className="color-red"></FaHeart>
              </span>
              <span style={{ cursor: "pointer" }} className="mx-3">
                <FaShoppingCart className="color-red" />
              </span>
            </div>
          </div>

          <div className="product border border-success round pt-4 mx-1 my-2">
            <div className="text-center">
              <img src={product3} width="170px" alt="not found" />
            </div>
            <h5 className="product-title size3 px-3 pb-3 mt-2">قرقوروت پفکی</h5>
            <h6 className="product-price color-red digits px-3 pb-1 ms-3 fw-bold">18,000 تومان</h6>
            <div className="d-flex justify-content-center justify-content-sm-start ms-3 px-3 mb-4">
              <span style={{ cursor: "pointer" }}>
                <FaHeart className="color-red"></FaHeart>
              </span>
              <span style={{ cursor: "pointer" }} className="mx-3">
                <FaShoppingCart className="color-red" />
              </span>
            </div>
          </div>

          <div className="product border border-success round pt-4 mx-1 my-2">
            <div className="text-center">
              <img src={product4} width="170px" alt="not found" />
            </div>
            <h5 className="product-title size3 px-3 pb-3 mt-2">ارده</h5>
            <h6 className="product-price color-red digits px-3 pb-1 ms-3 fw-bold">70,000 تومان</h6>
            <div className="d-flex justify-content-center justify-content-sm-start ms-3 px-3 mb-4">
              <span style={{ cursor: "pointer" }}>
                <FaHeart className="color-red"></FaHeart>
              </span>
              <span style={{ cursor: "pointer" }} className="mx-3">
                <FaShoppingCart className="color-red" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
